import { useWizard } from '@portals/framework';

import { ProductWizardContext, StepId } from './types';

export function useProductWizard() {
  return useWizard<ProductWizardContext, StepId>();
}
